import { ScholarshipServicePath } from "utils/constants";
import { buildFilterQueryString, buildQueryString } from "utils/helpers";

export const scholarshipRequests = {
  // Applications
  getScholarshipApplications: (params = {}) => `${ScholarshipServicePath}applications${buildFilterQueryString(params)}`,
  approveScholarshipApplication: id => `${ScholarshipServicePath}applications/${id}/approve`,
  blacklistScholarshipApplication: () => `${ScholarshipServicePath}scholarships/blacklist`,
  getApprovedScholarshipApplications: (params = {}) =>
    `${ScholarshipServicePath}applications/approved${buildFilterQueryString(params)}`,
  updateApprovedScholarshipStatus: () => `${ScholarshipServicePath}applications/approved/status`,
  getApprovedScholarshipBudgetInfo: (params = {}) =>
    `${ScholarshipServicePath}applications/approved/budget-info${buildFilterQueryString(params)}`,

  returnScholarshipForCorrection: id => `${ScholarshipServicePath}applications/${id}/return-for-correction`,

  // Scholarships
  updateScholarshipAmount: () => `${ScholarshipServicePath}scholarships/amount`,

  // Campaigns
  finalizeScholarshipCampaign: campaignId =>
    `${ScholarshipServicePath}campaigns/finalize${buildQueryString({ CampaignId: campaignId })}`,

  // Budgets
  updateScholarshipBudgetStructuralUnit: budgetId => `${ScholarshipServicePath}budgets/${budgetId}/structural-unit`,
  getScholarshipBudgetByYear: fiscalYear => `${ScholarshipServicePath}budgets/years/${fiscalYear}/expanded`,
  addScholarshipBudgetForStructuralUnit: (fiscalYear, structuralUnitId) =>
    `${ScholarshipServicePath}budgets/years/${fiscalYear}/structural-unit/${structuralUnitId}`,

  // Selects
  getScholarshipCampaignsSelect: () => `${ScholarshipServicePath}campaigns/select`,
};
